import React from 'react';

import { Link } from 'react-router-dom';

import classNames from 'classnames/bind';
import style from './Menu.scss';

const ctx = classNames.bind(style);

const MENU_ITEMS = [
  {
    title: 'Private Banking - от финансов до стиля жизни',
    url: {
      pathname: '/overview',
    },
  },
  {
    title: 'Цифровые капиталы ',
    url: {
      pathname: '/digital',
    },
  },
  {
    title: 'Забота о благосостоянии',
    url: {
      pathname: '/invest',
    },
  },
  {
    title: '«Наш внутренний девиз — у нас всегда есть решение»',
    url: {
      pathname: '/interview',
    },
  },
];

class Menu extends React.Component {
  state = {
    isOpened: false,
  };

  toggleMenu = () => {
    this.setState(({ isOpened }) => ({
      isOpened: !isOpened,
    }));
  };

  render() {
    const { isOpened } = this.state;

    return (
      <div className={ctx('menu')} onClick={this.toggleMenu}>
        <div className={ctx('trigger', { 'trigger--isOpened': isOpened })}>
          Показать статьи
        </div>
        {isOpened && (
          <div className={ctx('overlay')}>
            {MENU_ITEMS.map(({ title, url }, idx) => (
              <Link className={ctx('overlay-item')} to={url} key={idx}>
                {title}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Menu;
